module.exports = __webpack_public_path__ + "img/collage.fe8d0fb0.png";